import React, { Fragment, useState, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { TextField, Typography } from '@mui/material';
import { Checkbox } from '../ui/checkbox'
import PropTypes from 'prop-types';
import { RxCross2 } from 'react-icons/rx';
import '../../Styles/Common.css'
import * as InputTypes from '../../Entities/InputTypes'

const MultiTaskTextArea = ({
    onValueChange,
    value,
    name = '',
    errors,
    placeholder,
    rules,
    className,
    control,
    label,
    required,
    key,
    isTagGovernance = false,
    isMinutesOfMeeting = false,
    isTasks = false,
    isAgenda = false
}) => {
    const { control: formControl } = useForm();
    const [agenda, setAgenda] = useState([]);
    const [minutes, setMinutes] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [tagGovernance, setTagGovernance] = useState([]);
    const textAreaRef = useRef(null);

    const handleEnter = (e) => {
        if (e.key === InputTypes.ENTER && e.target.value.trim() !== '') {
            if (isMinutesOfMeeting) {
                setMinutes([...minutes, e.target.value]);
            } else if (isAgenda) {
                setAgenda([...agenda, e.target.value]);
            } else if (isTagGovernance) {
                setTagGovernance([...tagGovernance, e.target.value]);
            } else if (isTasks) {
                setTasks([...tasks, e.target.value]);
            }
            e.target.value = '';
        }
    };

    const handleDeleteTask = (index) => {
        if (isTagGovernance) {
            const updatedTagGovernance = [...tagGovernance];
            updatedTagGovernance.splice(index, 1);
            setTagGovernance(updatedTagGovernance);
        } else if (isTasks) {
            const updatedTasks = [...tasks];
            updatedTasks.splice(index, 1);
            setTasks(updatedTasks);
        }
    };
    const handleClick = () => {
        textAreaRef.current.focus()
    }

    return (
        <Fragment onClick={handleClick}>
            {label && (
                <Typography variant="subtitle1">
                    {label}
                    {required && <span className="text-danger">*</span>}
                </Typography>
            )}
            <Controller
                name={name}
                control={control || formControl}
                rules={rules}
                render={({ field: { onChange } }) => (
                    <TextField
                        className='multitask-textarea'
                        fullWidth
                        placeholder='Enter'
                        onChange={onValueChange}
                        onKeyDown={handleEnter}
                        inputRef={textAreaRef}
                        InputProps={{
                            startAdornment: (
                                <div className={isMinutesOfMeeting || isAgenda ? "adornment-container" : "adornment-container-two"}>
                                    {(isMinutesOfMeeting ? minutes : isAgenda ? agenda : []).map((item, index) => (
                                        <div key={index} className='flex'>
                                            <Checkbox />
                                            <Typography variant="body1" ml={2} mb={2}>
                                                {item}
                                            </Typography>
                                        </div>
                                    ))}
                                    {(isTagGovernance ? tagGovernance : isTasks ? tasks : []).map((item, index) => (
                                        <div key={index} className='flex'>
                                            <Typography variant="body1" style={{ textDecoration: 'underline' }}>
                                                {item}
                                            </Typography>
                                            <RxCross2 size={22} className="ml-2 mr-3 cursor-pointer" onClick={() => handleDeleteTask(index)} />
                                        </div>
                                    ))}
                                </div>
                            ),
                        }}
                    />
                )}
            />
            <p className="grc-error-msg text-danger">{errors && name && errors[name]?.message}</p>
        </Fragment>
    );
};

MultiTaskTextArea.propTypes = {
    className: PropTypes.string,
    value: PropTypes.any,
    onValueChange: PropTypes.func,
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.any,
    rules: PropTypes.object,
    control: PropTypes.any,
    required: PropTypes.bool,
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isMinutesOfMeeting: PropTypes.bool,
    isTagGovernance: PropTypes.bool,
    isTasks: PropTypes.bool,
    isAgenda: PropTypes.bool
};

export default MultiTaskTextArea;
